
import React from "react";
import { Button, Form, Modal, OverlayTrigger } from "react-bootstrap";
import { useTranslation, withTranslation } from "react-i18next";

import { BiInfoCircle } from "react-icons/bi";
import Utils from "../../../../../core/utilities/Utils";
import social from '../../../../../images/Social_icon.png';
import environmental from '../../../../../images/environment.png';
import governance from '../../../../../images/governance_icon.png';

const MaterialityImpactSelectionModal = ({ t,
	validated,
	mode = 'EDIT',
	topicDetails,
	financialImpact,
	materialityImpact,
	importanceImpact,
	onFinancialImpactChange,
	onMaterialityImpactChange,
	onImportanceImpactChange,
	onClose,
	onSave,
	show = false,
	materialityType
}) => {
	const { k, i18n } = useTranslation();

	return (
		<Modal show={show}
			onHide={onClose}
			size="90w"
			aria-labelledby="contained-modal-title-vcenter"
			centered backdrop="static"
			keyboard={false}>
			<Modal.Header closeButton className='border-0 bg-white SMHead014'>
				<Modal.Title bsPrefix="modal-title" as="h5" className='pt-3 px-3 w-100'>
					<div className='Single_MIC01_02 '>
						{topicDetails.category === 'ENVIRONMENTAL' && (
							<div className="Single_MIC01_img_02 environmentalimg">
								<img src={environmental} />
							</div>
						)}
						{topicDetails.category === 'SOCIAL' && (
							<div className="Single_MIC01_img_02 Socialimg">
								<img src={social} />
							</div>
						)}
						{topicDetails.category === 'GOVERNANCE' && (
							<div className="Single_MIC01_img_02 governanceimg">
								<img src={governance} />
							</div>
						)}
						{(i18n.language && topicDetails[i18n.language])
							? topicDetails[i18n.language]
							: topicDetails?.name ?? 'Selected Issue'}
					</div>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className='pt-1'>
				<Form noValidate validated={validated}>
					<div className=''>
						<div className='MaterialityScoreCard02'>
							{materialityType === 'Double' ? (
								<>
									<div className='MaterialityScoreCard02_in'>
										<h5>{t("ImpactMateriality.label")} <span className='text-danger'>*</span>	
											<OverlayTrigger
												placement="top"
												overlay={Utils.renderTooltip(
													t('ImpactMaterialityInfo.label')
												)}>
												<span className='font-18 ms-2'><BiInfoCircle /></span>
											</OverlayTrigger>
										</h5>
										<div className='MaterialityScoreCard_add'>
											<ul>
												<li>
													<h6>{t("Scale.label")}
														<OverlayTrigger
															placement="top"
															overlay={Utils.renderTooltip(
																t('IMScaleQn.label')
															)}>
															<span className='font-18 ms-2'><BiInfoCircle /></span>
														</OverlayTrigger></h6>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>0</span> {t("NoImpact.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact1"
														id={`impact-11`}
														checked={materialityImpact.scale === 'NO'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, scale: 'NO' })}
														required
														disabled={mode === 'VIEW'}
													/>

												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>1</span> {t("LowImpact.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact1"
														id={`impact-12`}
														checked={materialityImpact.scale === 'LOW'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, scale: 'LOW' })}
														required
														disabled={mode === 'VIEW'}
													/>

												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>2</span> {t("MediumImpact.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact1"
														id={`impact-13`}
														checked={materialityImpact.scale === 'MEDIUM'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, scale: 'MEDIUM' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>3</span> {t("HighImpact.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact1"
														id={`impact-14`}
														checked={materialityImpact.scale === 'HIGH'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, scale: 'HIGH' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>4</span> {t("VeryHighImpact.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact1"
														id={`impact-15`}
														checked={materialityImpact.scale === 'VERY_HIGH'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, scale: 'VERY_HIGH' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
											</ul>
										</div>

										<div className='MaterialityScoreCard_add'>
											<ul>
												<li>
													<h6>{t("Scope.label")}
														<OverlayTrigger
															placement="top"
															overlay={Utils.renderTooltip(
																t('IMScopeQn.label')
															)}>
															<span className='font-18 ms-2'><BiInfoCircle /></span>
														</OverlayTrigger></h6>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>0</span> {t("NoEffect.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact2"
														id={`impact-21`}
														checked={materialityImpact.scope === 'NO'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, scope: 'NO' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>1</span> {t("LowEffect.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact2"
														id={`impact-22`}
														checked={materialityImpact.scope === 'LOW'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, scope: 'LOW' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>2</span> {t("MediumEffect.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact2"
														id={`impact-23`}
														checked={materialityImpact.scope === 'MEDIUM'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, scope: 'MEDIUM' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>3</span> {t("HighEffect.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact2"
														id={`impact-24`}
														checked={materialityImpact.scope === 'HIGH'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, scope: 'HIGH' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>4</span> {t("VeryHighEffect.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact2"
														id={`impact-25`}
														checked={materialityImpact.scope === 'VERY_HIGH'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, scope: 'VERY_HIGH' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
											</ul>
										</div>

										<div className='MaterialityScoreCard_add'>
											<ul>
												<li>
													<h6>{t("Irremediability.label")}
														<OverlayTrigger
															placement="top"
															overlay={Utils.renderTooltip(
																t('IMInterQn.label')
															)}>
															<span className='font-18 ms-2'><BiInfoCircle /></span>
														</OverlayTrigger></h6>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>0</span> {t("CanBeFullyMitigatedOrReversed.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact3"
														id={`impact-31`}
														checked={materialityImpact.irremediability === 'NO'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, irremediability: 'NO' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>1</span> {t("CanBeMitigatedOrReversedToLargeExtent.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact3"
														id={`impact-32`}
														checked={materialityImpact.irremediability === 'LOW'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, irremediability: 'LOW' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>2</span> {t("CanBeMitigatedOrReversedToMediumExtent.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact3"
														id={`impact-33`}
														checked={materialityImpact.irremediability === 'MEDIUM'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, irremediability: 'MEDIUM' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>3</span> {t("CanBeMitigatedOrReversedToSmallExtent.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact3"
														id={`impact-34`}
														checked={materialityImpact.irremediability === 'HIGH'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, irremediability: 'HIGH' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>4</span> {t("NoPossibilityToMitigateOrReverse.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact3"
														id={`impact-35`}
														checked={materialityImpact.irremediability === 'VERY_HIGH'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, irremediability: 'VERY_HIGH' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
											</ul>
											{/* <div className='MRCard'>
											(  {t("MitigatedOrReversed.label")} )
										</div> */}
										</div>
										<div className='MaterialityScoreCard_add'>
											<ul>
												<li>
													<h6>{t("Likelihood.label")}
														<OverlayTrigger
															placement="top"
															overlay={Utils.renderTooltip(
																t('IMLikelihoodQn.label')
															)}>
															<span className='font-18 ms-2'><BiInfoCircle /></span>
														</OverlayTrigger></h6>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>0</span> {t("NotPossibleToOccur.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact4"
														id={`impact-41`}
														checked={materialityImpact.likelihood === 'NO'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, likelihood: 'NO' })}
														required
														disabled={mode === 'VIEW'}
													/>

												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>1</span> {t("VeryMinimalPossibilityToOccur.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact4"
														id={`impact-42`}
														checked={materialityImpact.likelihood === 'LOW'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, likelihood: 'LOW' })}
														required
														disabled={mode === 'VIEW'}
													/>

												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>2</span> {t("LikelyToOccur.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact4"
														id={`impact-43`}
														checked={materialityImpact.likelihood === 'MEDIUM'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, likelihood: 'MEDIUM' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>3</span> {t("HighlyLikelyToOccur.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact4"
														id={`impact-44`}
														checked={materialityImpact.likelihood === 'HIGH'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, likelihood: 'HIGH' })}
														required
														disabled={mode === 'VIEW'}
													/>

												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>4</span> {t("DefinitelyWillOccur.label")}
															</>
														}
														className="DataTypeCheck"
														name="impact4"
														id={`impact-45`}
														checked={materialityImpact.likelihood === 'VERY_HIGH'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, likelihood: 'VERY_HIGH' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
											</ul>
										</div>
										<div className='mt-2'>
											<h6>{t("ReasonForChoosingWeightage.label")} <span className='text-danger'>*</span></h6>
											<textarea className='form-control mt-1' rows={3}
												value={materialityImpact.reason}
												onChange={(e) => onMaterialityImpactChange({ ...materialityImpact, reason: e.target.value })}
												required
												disabled={mode === 'VIEW'}>
											</textarea>
										</div>
									</div>
									<div className='MaterialityScoreCard02_in'>
										<h5>{t("FinancialMateriality.label")} <span className='text-danger'>*</span>
											<OverlayTrigger
												placement="top"
												overlay={Utils.renderTooltip(
													t('FinancialMaterialityInfo.label')
												)}>
												<span className='font-18 ms-2'><BiInfoCircle /></span>
											</OverlayTrigger>
										</h5>
										<div className='MaterialityScoreCard_add'>
											<ul>
												<li>
													<h6>{t("Magnitude.label")}
														<OverlayTrigger
															placement="top"
															overlay={Utils.renderTooltip(
																t('FMManitudeQn.label')
															)}>
															<span className='font-18 ms-2'><BiInfoCircle /></span>
														</OverlayTrigger></h6>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>0</span> {t("NoImpact.label")}
															</>
														}
														className="DataTypeCheck"
														name="financial1"
														id={`financial-11`}
														checked={financialImpact.range === 'NO'}
														onChange={() => onFinancialImpactChange({ ...financialImpact, range: 'NO' })}
														disabled={mode === 'VIEW'}
														required
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>1</span> {t("LowImpact.label")}
															</>
														}
														className="DataTypeCheck"
														name="financial1"
														id={`financial-12`}
														checked={financialImpact.range === 'LOW'}
														onChange={() => onFinancialImpactChange({ ...financialImpact, range: 'LOW' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>2</span> {t("MediumImpact.label")}
															</>
														}
														className="DataTypeCheck"
														name="financial1"
														id={`financial-13`}
														checked={financialImpact.range === 'MEDIUM'}
														onChange={() => onFinancialImpactChange({ ...financialImpact, range: 'MEDIUM' })}
														required
														disabled={mode === 'VIEW'}
													/>

												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>3</span> {t("HighImpact.label")}
															</>
														}
														className="DataTypeCheck"
														name="financial1"
														id={`financial-14`}
														checked={financialImpact.range === 'HIGH'}
														onChange={() => onFinancialImpactChange({ ...financialImpact, range: 'HIGH' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>4</span> {t("VeryHighImpact.label")}
															</>
														}
														className="DataTypeCheck"
														name="financial1"
														id={`financial-15`}
														checked={financialImpact.range === 'VERY_HIGH'}
														onChange={() => onFinancialImpactChange({ ...financialImpact, range: 'VERY_HIGH' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
											</ul>
										</div>
										<div className='MaterialityScoreCard_add'>
											<ul>
												<li>
													<h6>{t("Likelihood.label")}
														<OverlayTrigger
															placement="top"
															overlay={Utils.renderTooltip(
																t('FMLikelihoodQn.label')
															)}>
															<span className='font-18 ms-2'><BiInfoCircle /></span>
														</OverlayTrigger></h6>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>0</span> {t("NotPossibleToOccur.label")}
															</>
														}
														className="DataTypeCheck"
														name="financial2"
														id={`financial-21`}
														checked={financialImpact.likelihood === 'NO'}
														onChange={() => onFinancialImpactChange({ ...financialImpact, likelihood: 'NO' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>1</span> {t("VeryMinimalPossibilityToOccur.label")}
															</>
														}
														className="DataTypeCheck"
														name="financial2"
														id={`financial-22`}
														checked={financialImpact.likelihood === 'LOW'}
														onChange={() => onFinancialImpactChange({ ...financialImpact, likelihood: 'LOW' })}
														required
														disabled={mode === 'VIEW'}
													/>

												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>2</span> {t("LikelyToOccur.label")}
															</>
														}
														className="DataTypeCheck"
														name="financial2"
														id={`financial-23`}
														checked={financialImpact.likelihood === 'MEDIUM'}
														onChange={() => onFinancialImpactChange({ ...financialImpact, likelihood: 'MEDIUM' })}
														required
														disabled={mode === 'VIEW'}
													/>

												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>3</span> {t("HighlyLikelyToOccur.label")}
															</>
														}
														className="DataTypeCheck"
														name="financial2"
														id={`financial-24`}
														checked={financialImpact.likelihood === 'HIGH'}
														onChange={() => onFinancialImpactChange({ ...financialImpact, likelihood: 'HIGH' })}
														required
														disabled={mode === 'VIEW'}
													/>

												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>4</span> {t("DefinitelyWillOccur.label")}
															</>
														}
														className="DataTypeCheck"
														name="financial2"
														id={`financial-25`}
														checked={financialImpact.likelihood === 'VERY_HIGH'}
														onChange={() => onFinancialImpactChange({ ...financialImpact, likelihood: 'VERY_HIGH' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
											</ul>
										</div>
										<div className='mt-2'>
											<h6>{t("ReasonForChoosingWeightage.label")} <span className='text-danger'>*</span></h6>
											<textarea className='form-control mt-1' rows={3}
												value={financialImpact.reason}
												onChange={(e) => onFinancialImpactChange({ ...financialImpact, reason: e.target.value })}
												required
												disabled={mode === 'VIEW'}>
											</textarea>
										</div>
									</div>

								</>
							) : (
								// Single Materiality Type
								<>
									<div className='MaterialityScoreCard02_in'>
										<h5>{t("SingleMaterialityImpact.label")}
											<OverlayTrigger
												placement="auto"
												overlay={Utils.renderTooltip(
													t('SingleMaterialityImpactInfo.label')
												)}>
												<span className='font-18 ms-2'><BiInfoCircle /></span>
											</OverlayTrigger>
										</h5>
										<div className='MaterialityScoreCard_add'>
											<ul>
												<li style={{marginRight: '-150px'}}>
													{/* <h6>{t("SingleMaterialityImpact.label")}
														<OverlayTrigger
															placement="top"
															overlay={Utils.renderTooltip(
																t('SingleMaterialityImpactInfo.label')
															)}>
															<span className='font-18 ms-2'><BiInfoCircle /></span>
														</OverlayTrigger>
													</h6> */}
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>0</span> {t("NoImpact.label")}
															</>
														}
														className="DataTypeCheck"
														name="singleImpact"
														id={`single-impact-0`}
														checked={materialityImpact?.scale === 'NO'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, scale: 'NO' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>1</span> {t("LowImpact.label")}
															</>
														}
														className="DataTypeCheck"
														name="singleImpact"
														id={`single-impact-1`}
														checked={materialityImpact?.scale === 'LOW'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, scale: 'LOW' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>2</span> {t("MediumImpact.label")}
															</>
														}
														className="DataTypeCheck"
														name="singleImpact"
														id={`single-impact-2`}
														checked={materialityImpact?.scale === 'MEDIUM'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, scale: 'MEDIUM' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>3</span> {t("HighImpact.label")}
															</>
														}
														className="DataTypeCheck"
														name="singleImpact"
														id={`single-impact-3`}
														checked={materialityImpact?.scale === 'HIGH'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, scale: 'HIGH' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>4</span> {t("VeryHighImpact.label")}
															</>
														}
														className="DataTypeCheck"
														name="singleImpact"
														id={`single-impact-4`}
														checked={materialityImpact?.scale === 'VERY_HIGH'}
														onChange={() => onMaterialityImpactChange({ ...materialityImpact, scale: 'VERY_HIGH' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
											</ul>
										</div>
										<div className='mt-2'>
											<h6>{t("ReasonForSelection.label")} <span className='text-danger'>*</span></h6>
											<textarea className='form-control mt-1' rows={3}
												value={materialityImpact?.reason}
												onChange={(e) => onMaterialityImpactChange({ ...materialityImpact, reason: e.target.value })}
												required
												disabled={mode === 'VIEW'}>
											</textarea>
										</div>
									</div>
									<div className='MaterialityScoreCard02_in'>
										<h5>{t("SingleMaterialityImportance.label")}
											<OverlayTrigger
												placement="auto"
												overlay={Utils.renderTooltip(
													t('SingleMaterialityImportanceInfo.label')
												)}>
												<span className='font-18 ms-2'><BiInfoCircle /></span>
											</OverlayTrigger>
										</h5>
										<div className='MaterialityScoreCard_add'>
											<ul>
												<li style={{marginRight: '-150px'}}>
													{/* <h6>{t("SingleMaterialityImportance.label")}
														<OverlayTrigger
															placement="top"
															overlay={Utils.renderTooltip(
																t('SingleMaterialityImportanceInfo.label')
															)}>
															<span className='font-18 ms-2'><BiInfoCircle /></span>
														</OverlayTrigger>
													</h6> */}
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>0</span> {t("NoImportance.label")}
															</>
														}
														className="DataTypeCheck"
														name="singleImportance"
														id={`single-importance-0`}
														checked={importanceImpact?.scale === 'NO'}
														onChange={() => onImportanceImpactChange({ ...importanceImpact, scale: 'NO' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>1</span> {t("LowImportance.label")}
															</>
														}
														className="DataTypeCheck"
														name="singleImportance"
														id={`single-importance-1`}
														checked={importanceImpact?.scale === 'LOW'}
														onChange={() => onImportanceImpactChange({ ...importanceImpact, scale: 'LOW' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>2</span> {t("MediumImportance.label")}
															</>
														}
														className="DataTypeCheck"
														name="singleImportance"
														id={`single-importance-2`}
														checked={importanceImpact?.scale === 'MEDIUM'}
														onChange={() => onImportanceImpactChange({ ...importanceImpact, scale: 'MEDIUM' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>3</span> {t("HighImportance.label")}
															</>
														}
														className="DataTypeCheck"
														name="singleImportance"
														id={`single-importance-3`}
														checked={importanceImpact?.scale === 'HIGH'}
														onChange={() => onImportanceImpactChange({ ...importanceImpact, scale: 'HIGH' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
												<li>
													<Form.Check
														type="radio"
														inline
														label={
															<>
																<span>4</span> {t("VeryHighImportance.label")}
															</>
														}
														className="DataTypeCheck"
														name="singleImportance"
														id={`single-importance-4`}
														checked={importanceImpact?.scale === 'VERY_HIGH'}
														onChange={() => onImportanceImpactChange({ ...importanceImpact, scale: 'VERY_HIGH' })}
														required
														disabled={mode === 'VIEW'}
													/>
												</li>
											</ul>
										</div>
										<div className='mt-2'>
											<h6>{t("ReasonForSelection.label")} <span className='text-danger'>*</span></h6>
											<textarea className='form-control mt-1' rows={3}
												value={importanceImpact?.reason}
												onChange={(e) => onImportanceImpactChange({ ...importanceImpact, reason: e.target.value })}
												required
												disabled={mode === 'VIEW'}>
											</textarea>
										</div>
									</div>
								</>
							)}
						</div>
					</div>
					{
						mode !== 'VIEW' &&
						<div className='text-center'>
							<Button variant="secondary" className='me-2 px-3' onClick={() => onClose()}>
								{t("Close.label")}
							</Button>
							<Button variant="primary" className='px-3' onClick={(e) => onSave(e)}>
								{t("Save.label")}
							</Button>
						</div>
					}
				</Form>
			</Modal.Body>
		</Modal>
	);
};

export default withTranslation()(MaterialityImpactSelectionModal);


